import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import UserList from '../components/users/UserList'
import { useGetUserInfo } from '../hooks/useGetUserInfo'
import { useIsSecurityUserWithLoading } from '../hooks/useIsSecurityUserWithLoading'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { userTypes } from '../utils/constants'

export default function SecurityUsersPage() {
  const history = useHistory()

  const { isSecurityUser, loading } = useIsSecurityUserWithLoading()
  const userInfo = useGetUserInfo()
  if (loading) return null

  if (!isSecurityUser) {
    history.push('/usuarios')
  }

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        {isSecurityUser && userInfo?.building && (
          <UserList
            building={userInfo?.building}
            redirectTo={history.location.pathname}
            showOnlyUsers={false}
            isSecurityUser={isSecurityUser}
            initialType={userTypes.security}
          />
        )}
      </Container>
    </main>
  )
}
